class LinksSlider {
    constructor() {
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sliderRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const element = document.querySelector('.program-bottom-links');
        this.slider = element?.querySelector('.links-wrapper') ?? null;
        this.prevArrow = element?.querySelector('.slick-slider-arrow-prev') ?? undefined;
        this.nextArrow = element?.querySelector('.slick-slider-arrow-next') ?? undefined;
    }
    init() {
        if (globalThis.matchMedia('(max-width: 767px)').matches) {
            this.initializeSlider();
        }
        else {
            this.removeSlider();
        }
    }
    initializeSlider() {
        if (!this.sliderRef && this.slider) {
            this.sliderRef = jQuery(this.slider).slick({
                fade: true,
                prevArrow: this.prevArrow,
                nextArrow: this.nextArrow,
                lazyLoad: 'progressive',
                rows: 0,
                centerMode: true,
            });
            const slides = jQuery('.program-bottom-links').find('.slick-slide').length;
            const slideCenter = Math.floor(slides / 2);
            jQuery(this.slider).slick('slickGoTo', slideCenter);
        }
    }
    removeSlider() {
        if (this.sliderRef) {
            this.sliderRef.slick('unslick');
            this.sliderRef = undefined;
        }
    }
}
export default new LinksSlider();
